import React, { useState } from "react";
import useAxios from "../../utils/useAxios";
import { Link, useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  //const [confirmPassword, setConfirmPassword] = useState("");

  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [sumbitOtpLoading, setSumbitOtpLoading] = useState(false);

  const axiosApi = useAxios();
  const navigate = useNavigate();

  const validatePhoneNumber = (input) => /^[0-9]{10}$/.test(input);

  const handleSendOtp = async (e) => {
    e.preventDefault();
    if (!validatePhoneNumber(phoneNumber)) {
      setError("Please enter a valid 10-digit phone number.");
      return;
    }

    setError("");
    setSuccess("");
    setLoading(true);

    try {
      await axiosApi.post(`/api/auth/forgot-password`, {
        phoneNumber,
      });

      setStep(2); // move to OTP input step
      setSuccess("OTP has been sent to your phone.");
    } catch (err) {
      setError(err.response?.data?.message || "Failed to send OTP.");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyAndReset = async (e) => {
    e.preventDefault();
    if (!otp || !newPassword) {
      setError("All fields are required.");
      return;
    }

    // if (newPassword !== confirmPassword) {
    //   setError("Passwords do not match.");
    //   return;
    // }

    setError("");
    setSuccess("");
    setSumbitOtpLoading(true);

    try {
      await axiosApi.post(`/api/auth/verify-reset-password`, {
        phoneNumber,
        otp,
        newPassword,
      });

      setSuccess("Password reset successfully. You can now log in.");
      setStep(1);
      setOtp("");
      setNewPassword("");
      //   setConfirmPassword("");
      setPhoneNumber("");

      setTimeout(()=>{
        navigate("/login")
      },3000)

    } catch (err) {
      setError(err.response?.data?.message || "OTP verification failed.");
    } finally {
      setSumbitOtpLoading(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div
        className="card log-card p-4"
        style={{ maxWidth: 400, width: "100%" }}
      >
        <div className="mb-4 text-center">
          <img
            src="/icon/main-logo-full.png"
            alt="Logo"
            className="img-fluid mb-3 rounded-circle"
            width="140"
          />
          <h5 className="card-title log-title">Forgot Password</h5>
          <p className="text-muted">
            Please enter your phone number to receive a reset code.
          </p>
        </div>

        <form className="text-start">
          {/* Phone Input + Send/Resend OTP */}
          <div className="mb-3">
            <label htmlFor="phoneNumber" className="form-label">
              Phone Number
            </label>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                id="phoneNumber"
                placeholder="Enter your phone number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                required
                disabled={step === 2}
              />
              <button
                type="button"
                className={`btn ${
                  step === 1 ? "theme-button" : "btn-outline-secondary"
                }`}
                onClick={handleSendOtp}
                disabled={loading}
              >
                {loading
                  ? step === 1
                    ? "Sending..."
                    : "Resending..."
                  : step === 1
                  ? "Send OTP"
                  : "Resend OTP"}
              </button>
            </div>
          </div>

          {/* Step 2: OTP & New Password */}
          {step === 2 && (
            <>
              <div className="mb-3">
                <label htmlFor="otp" className="form-label">
                  Verify OTP
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="otp"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label htmlFor="newPassword" className="form-label">
                  Enter New Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="newPassword"
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </div>

              {/* <div className="mb-3">
                <label htmlFor="confirmPassword" className="form-label">
                  Confirm Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="confirmPassword"
                  placeholder="Confirm password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div> */}

              <button
                type="button"
                className="btn theme-button w-100"
                onClick={handleVerifyAndReset}
                disabled={sumbitOtpLoading}
              >
                {sumbitOtpLoading
                  ? "Resetting..."
                  : "Verify and Reset Password"}
              </button>
            </>
          )}

         { <Link to="/login" className="mt-2">Go Back to login</Link>}

          {/* Error & Success Message */}
          {error && <div className="text-danger mt-3">{error}</div>}
          {success && <div className="text-success mt-3">{success}</div>}
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
